<span
    class="goal-score"
    [class.component-goal-container]="
        opportunity?.view?.oppType === OpportunityType.COMPONENT
    "
    [style.backgroundColor]="opportunity?.view?.goalColour"
>
    <span
        [class.component-goal]="
            opportunity?.view?.oppType === OpportunityType.COMPONENT
        "
        *ngIf="opportunity?.view?.goalLabel"
    >
        <span
            [class.goal-value-symbol]="
                opportunity?.view?.oppType === OpportunityType.PENDING ||
                opportunity?.view?.oppType === OpportunityType.COMPONENT
            "
        >
            {{ opportunity?.view?.goalLabel | translate }}
        </span>
        <i
            class="component-count"
            *ngIf="opportunity?.view?.oppType === OpportunityType.COMPONENT"
        >
            {{ opportunity?.view?.goalBadgeLabel }}
        </i>
    </span>

    <cmps-icon
        [svgIcon]="opportunity?.view?.goalIcon"
        *ngIf="
            opportunity?.view?.goalIcon &&
            !opportunity?.view?.goalLabel &&
            opportunity?.view?.percentToGoal == null
        "
    ></cmps-icon>

    <ng-container
        *ngIf="
            !opportunity?.view?.goalLabel &&
            opportunity?.view?.percentToGoal != null
        "
    >
        <span class="goal-value">{{
            opportunity?.view?.percentToGoal | cmpsSdpNumber
        }}</span>
        <span class="score-percentage">%</span>
    </ng-container>
</span>
